import ReactMarkdown from 'react-markdown'
import { Box, styled } from '@mui/material'

import { DefaultElementProps } from 'common/interfaces'

import { MarkDown as MarkDownProps } from './interface'

const StyledDiv = styled(Box)({
  '& img': {
    maxWidth: '100%',
  },
})

export default function MarkDown({
  markdown,
  style,
}: MarkDownProps & DefaultElementProps): JSX.Element {
  if (Array.isArray(markdown)) {
    return (
      <StyledDiv className="markdown-wrap" sx={style ?? {}}>
        {markdown.map((text) => (
          <ReactMarkdown key={text}>{text}</ReactMarkdown>
        ))}
      </StyledDiv>
    )
  }

  const stringWithCorrectNewline = markdown.replace('\\n', '\n')

  return (
    <StyledDiv className="markdown-wrap" sx={style ?? {}}>
      <ReactMarkdown>{stringWithCorrectNewline}</ReactMarkdown>
    </StyledDiv>
  )
}
